export default __webpack_public_path__ + "static/media/white-check.308668de.svg";